import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll para o topo a cada mudança de rota (React Router) */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Desabilitar restauração automática de scroll do browser (pushState/popState)
  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
